export default __webpack_public_path__ + "static/following-button-icon-b68a68ad0536b853fc52d32b4e4370eb.png";